const DEFAULT_PICK_SCORING_QUEUE = 'pick-scoring';
/** Resolve the pick-scoring queue name, falling back to the default when unset or blank. */
export const resolvePickScoringQueue = (queueName) => {
    const trimmed = queueName?.trim();
    return trimmed ? trimmed : DEFAULT_PICK_SCORING_QUEUE;
};
// `@s2w/core` is isomorphic and the browser SPAs (frontend, admin) bundle this
// module, where there is no `process` global. Guard the reference itself:
// optional chaining only guards `process.env`, not a missing `process`, so an
// unguarded read throws `ReferenceError: process is not defined` at module load.
const queueNameFromEnv = typeof process !== 'undefined' ? process.env.PICK_SCORING_QUEUE_NAME : undefined;
export const PICK_SCORING_QUEUE = resolvePickScoringQueue(queueNameFromEnv);
//# sourceMappingURL=pick-scoring-message.js.map